<template><slot></slot></template>
<script lang="ts" setup>
import { checkGeoInside } from "@p-v/utils"
import { createPoint, createBounds, createPolygon } from "@p-v/utils/factory"
import { inject, onUnmounted, ref, watch, onMounted } from "vue"
import { requestAdapter } from "@p-v/api"
import type { Point, Size, Icon, Label } from "@p-v/packages/Map/map"

interface ComponentProps {
  points?: Point[]
  geojson?: string
  setting: {
    strokeColor: string
    strokeWeight: number
    strokeOpacity: number
    fillColor: string
    fillOpacity: number
  }
}

const props = withDefaults(defineProps<ComponentProps>(), {
  points: () => [],
  geojson: undefined,
  setting: () => ({
    strokeColor: "#4992FFFF",
    strokeWeight: 2,
    strokeOpacity: 0.8,
    fillColor: "#2BB7F740",
    fillOpacity: 0.2,
  }),
})

const emits = defineEmits(["rendered"])

const bmap = inject("bmap") as any

const overlay = ref<any>(undefined)

const pointsInstance = ref<Point[]>(props.points)

const checkInside = (point: Point) => {
  if (!overlay.value) return false
  return checkGeoInside(pointsInstance.value, point)

  // const bounds = overlay.value.getBounds()
  // console.log("bounds", bounds)
  // // 判断点是否在多边形内
  // return bounds.containsPoint(pointInstance)
}

const setViewport = () => {
  if (!overlay.value) return
  const bounds = overlay.value.getBounds()
  bmap.value.setViewport(bounds)
}

defineExpose({
  checkInside,
  setViewport,
})

const render = () => {
  if (overlay.value) {
    bmap.value?.removeOverlay(overlay.value)
  }
  if (pointsInstance.value?.length > 0) {
    const fencePoints = pointsInstance.value.map(point => createPoint(window.BMapGL, point))
    overlay.value = createPolygon(window.BMapGL, {
      path: fencePoints,
      opts: props.setting,
    })
    bmap.value.addOverlay(overlay.value)
    emits("rendered")
  } else {
    bmap.value?.removeOverlay(overlay.value)
    overlay.value = undefined
    emits("rendered")
  }
}

watch(
  () => props.points,
  value => {
    pointsInstance.value = value
    if (bmap.value) {
      render()
    }
  },
  { immediate: true, deep: true },
)

watch(
  () => bmap.value,
  value => {
    if (value && pointsInstance.value?.length > 0) {
      render()
    }
  },
  { immediate: true },
)
watch(
  () => pointsInstance.value,
  () => {
    if (bmap.value) {
      render()
    }
  },
  { deep: true, immediate: true },
)
onMounted(async () => {
  if (props.geojson) {
    // 加载geojson
    const jsonReq = await requestAdapter<{ [key: string]: string | number | boolean }>({
      url: props.geojson,
      method: "GET",
    })
    const waitBMap = watch(
      () => bmap.value,
      value => {
        if (value) {
          const gParse = new window.BMapGL.GeoJSONParse({})
          gParse.readFeaturesFromObject(jsonReq, { isPoints: true }, function (overlay) {
            console.log("overlay", overlay)
            pointsInstance.value = overlay.points
            render()
          })
          waitBMap()
        }
      },
      { immediate: true },
    )
  }
})
onUnmounted(() => {
  if (overlay.value) bmap.value?.removeOverlay(overlay.value)
})
</script>
